module.exports = __webpack_public_path__ + "TweetMySlides-logo-white-cropped.png?10e236427cb4e085febf98c8bd75e753";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TweetMySlides-logo-white-cropped.png
// module id = 128
// module chunks = 3